export enum EditGhostCalendarSuggestionStep {
	SendOptions = 'send-options',
	Subverticals = 'subverticals',
	Summary = 'summary',
	Tags = 'tags',
	Targets = 'targets',
}
